import { styled } from '@mui/system';
import Button from '@mui/material/Button';

const RoundButton = styled(Button)({
    borderRadius: 50,
});

export default RoundButton;
